import React, { useState, useEffect, useRef } from "react";
import { Link , NavLink} from "react-router-dom";
import classNames from "classnames";
import useScrollListener from "../../hooks/useScrollListener.js";
import IconLink from "../../elements/icon-link/index.js";
import MobileNavMenu from "../../sections/mobile-nav-menu";
import { RichText } from "@sitecore-jss/sitecore-jss-react";
import { gtag, getElementOffsetY } from "../../utils";
import { scrollToSmoothTryMultipleTimesByDataSourceid } from "../../hooks/scrollToSmooth.js";
import "./style.scss";

import { connect } from "react-redux";
import { selectUserState, selectHeaderHeight, selectShowCheckoutProgressBar, selectProgressBarData } from "../../selectors/application";
import Icon from "../../elements/icon/index.js";
import config from "../../temp/config";
import { AnimatePresence, motion } from "framer-motion";
import { apiAsia } from "../../utils/api-asia";

// Animations
import { curtainVariants, curtainVariantsAr } from "../../sections/mobile-nav-menu/animations";

import { toggleMenu, setHeaderHeight } from "../../redux/actions";
import { redirect, mobileIs, normalizeHref } from "../../utils/siteUtils";
import { useHistory } from "react-router-dom";
import { appendQuery } from "../../utils/urlHelper";
import useQuery from "../../utils/useQuery";
import { languages } from "i18next";

const HeaderBar = ({ logo, logoLink, menuItems, cart, newsletters, store, login, socialItems, regionIcon, page, forceVisible, checkoutProgressIndex = null, pathname, children, user, iconName, userNameClick, headerHeight, setHeaderHeight, showCart, lang, progressBarIndex, progressBarData, anchorPointList, rightAnchorPointList, showProgress, closeIcon, downIcon, list, globalTitle, electricImage, fuleImage, hybridImage,phevImage, backText }) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [directio, setDirectio] = useState('forward');
  const [rightCurrentIndex, setRightCurrentIndex] = useState(null);
  const [open, setOpen] = useState(true);
	const [showGlobal, setShowGlobal] = useState(false);
  const [scrollTop, setScrollTop] = useState(0);
	const [globalData, setGlobalData] = useState(list);
	const isMobile = mobileIs()
	const [showCarModel, setShowCarModel] = useState(false);
	const [carModelData, setCarModelData] = useState([]);
	const [showType, setShowType] = useState(null);
	const [activeId, setActiveId] = useState(null);
	const [slideActiveId, setSlideActiveId] = useState(null);
  const [selectedRegion, setSelectedRegion] = useState({
    country: "",
    language: ""
  });
  const { scrollDirection } = useScrollListener(forceVisible);
  const isAR = page?.fields?.rtl?.value;

  const headerNode = useRef();
  const menuRef = useRef(null); 
	const modelRef = useRef();
  
  let t = 0
  const onScroll = (e) => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth;
    let scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    setScrollTop(scrollTop)
    let headerContentDom = document.querySelector('.header-container')
    let progressDom = document.querySelector('.header-container .progress')
    if(progressDom) {
      progressDom.style.width = pageWidth * (scrollTop / (document.body.clientHeight - pageHeight)) + 'px';
    }

    if(t > scrollTop) {
      setDirectio('reverse')
      // 向上滚动
      if(scrollTop > 60) {
          headerContentDom.setAttribute('class', 'header-container end')
          if( !showProgress.value && headerContentDom ) headerContentDom.style.border = 'none'
      } else if(scrollTop === 0){
        headerContentDom.setAttribute('class', 'header-container')
      }
    } else {
      setDirectio('forward')
      // 向下滚动
      if(!headerContentDom.classList.contains('end')) {
        headerContentDom.setAttribute('class', 'header-container end')
      }
    }
    setTimeout(function(){ t = scrollTop },0)
  };

  useEffect(() => {
		if(isMenuOpen || showCarModel) {
			setShowGlobal(false);
		}
    isMenuOpen ? document.body.classList.add("no-scroll") : document.body.classList.remove("no-scroll");
  }, [isMenuOpen, showCarModel]);

  useEffect(() => {
    getHeaderHeight();

    let _selectedRegion = {};
    if (lang === "en") {
      _selectedRegion.country = config.webSettings.countrys[lang];
      _selectedRegion.language = "EN";
    } else if (lang.indexOf("-") !== -1) {
      let arr = lang.split("-");
      _selectedRegion.country = config.webSettings.countrys[arr[1]];
      _selectedRegion.language = arr[0].toUpperCase();
    }

    setSelectedRegion(_selectedRegion);
    window.addEventListener('scroll', onScroll)
    return () => {
      window.removeEventListener('scroll', onScroll);
    }
  }, []);

  const _newsletter = newsletters?.fields;
  const _login = login?.fields;
  const _store = store?.fields;

  const openRegionModal = id => {
    let elem = document.getElementById("regionModalId");
    if (elem) {
      if (elem.classList.contains("hide-modal")) {
        let regiModalCon = elem.querySelector(".modal-content.grid-story");
        if (!regiModalCon) {
          return false;
        }
        elem.classList.remove("hide-modal");
        elem.classList.add("show-modal");
        document.body.classList.add("show-modal");
        if (elem.scrollTo) {
          elem.scrollTo(0, 0);
        } else {
          elem.scrollTop = 0;
          elem.scrollLeft = 0;
        }
      } else if (elem.classList.contains("show-modal")) {
        elem.classList.add("hide-modal");
        elem.classList.remove("show-modal");
        document.body.classList.remove("show-modal");
      }
    }
  };

  const getHeaderHeight = () => {
    let height = headerHeight;
    if (headerNode?.current && !isMenuOpen) {
      height = headerNode?.current?.offsetHeight;
    }

    if (height !== headerHeight) {
      setHeaderHeight(height);
    }
  };

  useEffect(() => {
    let pageHeight = document.documentElement.clientHeight || document.body.offsetHeight || document.documentElement.offsetHeight;
    let pageWidth = document.documentElement.clientWidth || document.body.offsetWidth || document.documentElement.offsetWidth;
    if(open) {
      anchorPointList.forEach((item, index) => {
        let id = `{${item?.fields?.anchorPoint?.id?.toUpperCase()}}`;
        let element = document.querySelector(`[datasourceid="${id}"]`);
        if(directio == 'forward'){
          if(element?.getBoundingClientRect()?.top < 10 && element?.getBoundingClientRect()?.top > -pageHeight/2) {
            setCurrentIndex(index)
          }
        }
        if(directio == 'reverse'){
          if(element?.getBoundingClientRect()?.top > 10 && element?.getBoundingClientRect()?.top < pageHeight/2) {
            setCurrentIndex(index-1)
          }
        }
      })
    }
  }, [open, scrollTop]);

  const clickTab = (item, index) => {
    setCurrentIndex(index)
    setOpen(false)
    setTimeout(function(){
      setOpen(true)
    },500)
    let id = `{${item?.fields?.anchorPoint?.id?.toUpperCase()}}`;
    scrollToSmoothTryMultipleTimesByDataSourceid(id);
  };

  const clickRightTab = (item, index) => {
    setRightCurrentIndex(index)
    setCurrentIndex(anchorPointList.length-1)
    setOpen(false)
    setTimeout(function(){
      setOpen(true)
    },500)
    let id = `{${item?.fields?.anchorPoint?.id?.toUpperCase()}}`;
    scrollToSmoothTryMultipleTimesByDataSourceid(id);
  };

  const gtagLogoClick = (e, blean) => {
    setIsMenuOpen(blean);
    gtag('event', 'L_menu_logo_clk', {});
  }

  const gtagIconClick = (e, item) => {
    gtag('event', 'L_menu_clk', {
      'menu_name': normalizeHref(item?.fields?.link?.value?.href),
    });
  }

  const gtagLinkClick = (link) => {
    setIsMenuOpen(false);
		setShowCarModel(false);
		setActiveId(null);
		document.body.style.height = 'auto';
		document.body.style.overflowY = 'auto';
    gtag('event', 'L_menu_clk', {
      'menu_name': normalizeHref(link?.value?.href),
    });
  }
	
	const openGlobalModal = () => {
		setShowGlobal(!showGlobal);
		if(!showGlobal) {
			document.body.style.height = '100vh';
			document.body.style.overflowY = 'hidden';
			setIsMenuOpen(false);
			setShowCarModel(false);
		} else {
			document.body.style.height = 'auto';
			document.body.style.overflowY = 'auto';
		}
	};
	
	const closeGlobalModal = () => {
		document.body.style.height = 'auto';
		document.body.style.overflowY = 'auto';
		setShowGlobal(false);
	};
	
	const toggleCountry = (e, val) => {
		let data = JSON.parse(JSON.stringify(globalData));
		data.forEach((item) => {
			if(item.id === val.id) {
				item.showCountryList = !item.showCountryList;
			}
		})
		setGlobalData(data);
	};
	
	const itemAnimation = {
	  initial: "collapsed",
	  animate: "open",
	  exit: "collapsed",
	  variants: {
	    open: { opacity: 1, height: "auto" },
	    collapsed: { opacity: 0, height: 0 }
	  },
	  transition: { duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }
	};
	
	const mainMenuVariants = {
	  hidden: {
	    x: "-40px",
	    opacity: 0,
	    transition: {
	      when: "afterChildren",
	      staggerChildren: 0.1,
	      duration: 0.2
	    }
	  },
	  visible: {
	    x: 0,
	    opacity: 1,
	    transition: {
	      when: "beforeChildren",
	      staggerChildren: 0.1,
	      duration: 0.2
	    }
	  }
	};
	
	const mainMenuVariantsAr = {
	  hidden: {
	    x: "40px",
	    opacity: 0,
	    transition: {
	      when: "afterChildren",
	      staggerChildren: 0.1,
	      duration: 0.2
	    }
	  },
	  visible: {
	    x: 0,
	    opacity: 1,
	    transition: {
	      when: "beforeChildren",
	      staggerChildren: 0.1,
	      duration: 0.2
	    }
	  }
	};
	
	const toggleActiveMenuLevel = (subItems, showType, id, title) => {
		gtag('event', 'L_menu_clk', {
		  'menu_name': title?.value
		});
		let carModelData = [];
		setCarModelData(subItems)
		setShowType(showType?.fields?.phrase?.value)
	  setShowCarModel(true);
		document.body.style.height = '100vh';
		document.body.style.overflowY = 'hidden';
		setActiveId(id);
		setSlideActiveId(subItems[0].id);
		
		let timer = setTimeout((v) => {
			clearTimeout(timer);
			modelRef.current.addEventListener('scroll', handleScroll);
		}, 100)
		
	};
	
	const closeCarModel = () => {
		setShowCarModel(false);
		document.body.style.height = '100vh';
		document.body.style.overflowY = 'auto';
		setActiveId(null);
	};
	
	const clickSlideMenu = (item, showType) => {
    console.log(item.fields.link.value)
		if(showType !== 'carModel') {
      let a = document.createElement('a');
      a.setAttribute('href', normalizeHref(item?.fields?.link?.value?.href));
      a.setAttribute('target', item?.fields?.link?.value?.target);
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
			return false;
		}
    setSlideActiveId(item.id);
		let domClass = '.item_' + item.id;
		let dom = document.querySelectorAll(domClass)[0];
		let top = dom.getBoundingClientRect().top;
		let scrollTop = modelRef.current.scrollTop;
		modelRef.current.scrollTo({
		  top: top - 119 + scrollTop,
		  behavior: 'smooth',
		});
	};

  const tapSlideMenu = (id, showType) => {
		if(showType !== 'carModel') {
			setSlideActiveId(id);
		}
	};
	
	const handleScroll = () => {
		let scrollTop = modelRef.current.scrollTop;
    const menuRefEl = menuRef.current;
		let listDom = document.querySelectorAll('.pc_carmodel_item_carmodel');
    const menuTop = menuRefEl.getBoundingClientRect().top + window.pageYOffset;
		if(listDom?.length) {
			listDom.forEach((item, index) => {
				if(item.getBoundingClientRect().top < 240 && item.getBoundingClientRect().top > 0) {
          const menuItemId = item.id;
					setSlideActiveId(item.id);
          const menuItemEl = document.querySelector(`[id="${menuItemId}"]`);
          if (menuItemEl && menuRefEl) {
              const menuRect = menuItemEl.getBoundingClientRect();
              if (menuRect.top >= menuTop) {
                  menuRefEl.scrollTop += menuRect.top - menuRefEl.clientHeight;
              }   
          }
				}
			});
		}
	};
	
	const toDetail = (link) => {
		gtag('event', 'L_menu_clk', {
		  'menu_name': normalizeHref(link?.value?.href),
		});
		setShowCarModel(false);
		document.body.style.height = '100vh';
		document.body.style.overflowY = 'auto';
	};
	
	// 8.14新增埋点
	const regionClk = (name) => {
		gtag('event', 'L_region_clk', {
			'region_name': name
		});
	};
	
  return (
    <div
      className={classNames("header-container", {
        hide: !forceVisible && scrollDirection === "down" && !isMenuOpen,
        'rtl' : page?.fields?.rtl?.value
      })}
    >
      {showProgress?.value && <div className="progress"></div>}
      <div style={{ height: isMobile ? "46px" : "54px" }} className={classNames({hideProgress: !showProgress.value})}>
        <header className={classNames("header", { dark: isMenuOpen, "no-menu": progressBarIndex })} ref={headerNode}>
          <div className="logo-content">
            {!logoLink.value.href && <Logo {...logo.value} onClick={(e) => gtagLogoClick(e, false)} lang={lang} />}
            {logoLink.value.href && <LinkLogo {...logo.value} logoLink={logoLink} onClick={(e) => gtagLogoClick(e, false)} lang={lang} />}
          </div>
					
					{/* 一级菜单 */ }
					<div className="menu-items">
						<ul>
							{menuItems.map(({ id, fields: { link, title= [], subTitles = [], carCode={}, showType={} } }) => (
								<li key={id}>
									<MenuItem {...{ page, link, title, subTitles, carCode, isAR, showType, id, activeId }} onLinkClick={link => gtagLinkClick(link)} onIconClick={(subTitles, showType, id, title) => toggleActiveMenuLevel(subTitles, showType, id, title)} showIcon={!!subTitles.length} />
								</li>
							))}
						</ul>
					</div>
					
          <div className="other-links">
            {rightAnchorPointList?.map((item, index) => (
              <div className={"other-links__item"} key={item.id} onClick={(e) => gtagIconClick(e, item)}>
                {item?.fields?.link?.value?.href && <Link to={normalizeHref(item?.fields?.link?.value?.href)}>
                  <img src={item?.fields?.icon?.value?.src} />
                </Link>}
								{!item?.fields?.link?.value?.href && <div className="global" onClick={(e) => openGlobalModal()}>
									<img src={item?.fields?.icon?.value?.src} />
								</div>}
              </div>
            ))}
          </div>
					{showGlobal && !isMenuOpen && <div className={["global-model", page?.fields?.rtl?.value ? 'rtl' : null].join(' ')}>
						<div className="global-header">
							<RichText className="global-title" tag="div" field={globalTitle} />
							<div className="close" onClick={(e) => closeGlobalModal()}>
								<img src={closeIcon?.value?.src} />
							</div>
						</div>
						<div className="global-list">
							{globalData?.map((item, index) => {
							  return (
									<div className="global-area" key={item.id}>
										<div className="area" onClick={(e) => {toggleCountry(e, item)}}>
											<RichText className="area-name" tag="div" field={item?.fields.area} />
											<img className={["down", item?.showCountryList ? 'active' : null].join(' ')} src={downIcon?.value?.src} />
										</div>
										<AnimatePresence>
											{item?.showCountryList && <motion.div {...itemAnimation} className={["country-list", item?.showCountryList ? 'active' : null].join(' ')}>
												{item?.fields?.list?.length && item?.fields?.list?.map((el, i) => {
													return (
														<div className={["country-list-content", i > 2 ? 'active' : null].join(' ')}>
															{el?.fields?.link?.value?.href && <a target="_blank" className="country" href={normalizeHref(el?.fields?.link?.value?.href)} key={el.id} onClick={(e) => regionClk(el?.fields?.country?.value)}>{ el?.fields?.country?.value }</a>}
															{!el?.fields?.link?.value?.href && <span className={["country", i > 2 ? 'active' : null].join(' ')} onClick={(e) => regionClk(el?.fields?.country?.value)}>{ el?.fields?.country?.value }</span>}
														</div>
													)
												})}
											</motion.div>}
										</AnimatePresence>
									</div>
							  );
							})}
						</div>
					</div>}
        </header>
        {children}
      </div>
      
			{/* 二级菜单 */ }
			<AnimatePresence>
				{showCarModel && <motion.div className={classNames("pc_carmodel", showType === "carModel" ? 'active' : '')} variants={isAR ? mainMenuVariantsAr : mainMenuVariants} initial="hidden" exit="hidden" animate="visible">
					<div className="pc_carmodel_close" onClick={(e) => closeCarModel(e)}>
						<img src={closeIcon?.value?.src} />
					</div>
					<div className="pc_carmodel_menu" ref={menuRef}>
						{carModelData?.length && carModelData.map((item, index) => {
							return (
                <div key={index} onMouseOver={(e) => tapSlideMenu(item.id, showType)} onClick={(e) => clickSlideMenu(item, showType)}>
									{item?.fields?.carModelName?.value && <RichText className={classNames("pc_carmodel_menu_title", item.id === slideActiveId ? 'active' : '')} id={item.id} tag="div" field={item?.fields?.carModelName} />}
								</div>
							)
						})}
					</div>
					<div className={classNames("pc_carmodel_detail", showType === "carModel" ? 'active' : '')} ref={modelRef}>
						{carModelData?.length && carModelData.map((item, index) => {
							return (
								<div className={classNames("pc_carmodel_item", `item_${item.id}`, showType === "carModel" ? 'pc_carmodel_item_carmodel' : '' )} id={item.id} key={index}>
									{item.id === slideActiveId && showType !== "carModel" && item?.fields?.carModelName?.value && <a target={item?.fields?.link?.value?.target} href={normalizeHref(item?.fields?.link?.value?.href)} onClick={() => gtagLinkClick(item?.fields?.link)}><RichText className="carmodel_item_title_txet" tag="div" field={item?.fields?.carModelName} /></a>}
									{showType !== "carModel" && item.id === slideActiveId && item?.fields?.carModelImage?.value?.src && <a target={item?.fields?.link?.value?.target} href={normalizeHref(item?.fields?.link?.value?.href)} onClick={() => gtagLinkClick(item?.fields?.link)}>
										<div className="pc_carmodel_item_image">
											<img className="pc_carmodel_item_title" src={item?.fields?.carModelImage?.value?.src} />
										</div>
									</a>}
									{showType === "carModel" && item?.fields?.carModelImage?.value?.src && 
										<div className="pc_carmodel_item_titleContent">
											<img className="pc_carmodel_item_title" src={item?.fields?.carModelImage?.value?.src} />
										</div>
									}
									{showType === "carModel" && <div className={classNames("pc_carmodel_item_carcontent")}>
										{item?.fields?.subItems?.length && item?.fields?.subItems?.map((el, i) => {
											return (
												<NavLink to={normalizeHref(el?.fields?.link?.value?.href)} onClick={(e) => toDetail(el?.fields?.link)} className={classNames("pc_carmodel_item_content", i > 2 ? 'active' : '')} key={el.id}>
													{el?.fields?.carImage?.value?.src && <img className="pc_carmodel_item_content_carimage" src={el?.fields?.carImage?.value?.src} />}
													{showType === "carModel" && el?.fields?.carName?.value && <RichText className="pc_carmodel_item_content_carname" tag="div" field={el?.fields?.carName} />}
													{showType === "carModel" && <div className="pc_carmodel_item_content_cartype">
														{el?.fields?.carType?.fields?.key?.value === "electric" && <img className="pc_carmodel_item_content_cartype_img" src={electricImage?.value?.src} />}
														{el?.fields?.carType?.fields?.key?.value === "fuel" && <img className="pc_carmodel_item_content_cartype_img" src={fuleImage?.value?.src} />}
														{el?.fields?.carType?.fields?.key?.value === "hybrid" && <img className="pc_carmodel_item_content_cartype_img" src={hybridImage?.value?.src} />}
                            	{el?.fields?.carType?.fields?.key?.value === "Phev" && <img className="pc_carmodel_item_content_cartype_img" src={phevImage?.value?.src} />}
														{el?.fields?.carType?.fields?.phrase?.value && <RichText className={classNames("pc_carmodel_item_content_cartype_name", `theme-${el?.fields?.carType?.fields?.key?.value}`)} tag="div" field={el?.fields?.carType?.fields?.phrase} />}
													</div>}
													{showType === "carModel" && <div className="pc_carmodel_item_content_cartype_link">
														<div className="pc_carmodel_item_content_cartype_link_text">{el?.fields?.link?.value?.text}</div>
														{!isAR && <Icon name="ArrowRight" />}
														{isAR && <Icon name="ArrowLeft" />}
													</div>}
												</NavLink>
											)
										})}
									</div>}
								</div>
							);
						})}
					</div>
				</motion.div>}
			</AnimatePresence>
			
			{!progressBarIndex && (
        <MobileNavMenu
          {...{
            page,
            isAR,
            menuItems,
            setIsMenuOpen: setIsMenuOpen,
						socialItems,
						electricImage,
						fuleImage,
						hybridImage,
            phevImage,
						backText
          }}
          onClose={link => {
            gtagLinkClick(link)
          }}
          show={isMenuOpen}
        />
      )}
    </div>
  );
};

const MenuItem = ({ page, link, title, subTitles, showType, className, isAR, id, activeId, showIcon = false, isActive = false, carCode = {}, onLinkClick = () => {}, onIconClick = () => {} }) => (
	<div className={classNames("nav-link", className)}>
    {link.value.linktype === "internal" ? (
       page?.fields?.CarModel?.fields?.code?.value && carCode?.value == true ?
       (
        <NavLink to={normalizeHref(link.value.href)+'?car='+encodeURIComponent(page.fields.CarModel.fields.code.value)} activeClassName="active" onClick={() => onLinkClick(link)}>
          {link.value.text}
        </NavLink>
       ):(
        <NavLink to={normalizeHref(link.value.href)} activeClassName="active" onClick={() => onLinkClick(link)} className={[(link.value.id.toLowerCase()).indexOf(page?.itemId) === -1 ? '' : 'active1'].join(' ')}>
          {link.value.text}
        </NavLink>
       )
    ) : 
    link.value.href === "" ? (
      <div className={classNames("menu-title", id === activeId ? 'open' : '')} onClick={() => onIconClick(subTitles, showType, id, title)}>{title.value}</div>
    ):
    (
      <a href={normalizeHref(link.value.href)} target="_blank" rel="noopener noreferrer" onClick={() => onLinkClick(link)}>
        {link.value.text}
      </a>
    )}
  </div>
);

const Logo = ({ src, alt, title, onClick, lang }) => (
  <img src={src} alt={alt} className="logo" title={title} />
);

const LinkLogo = ({ src, alt, title, onClick, lang, logoLink }) => (
  <Link to={normalizeHref(logoLink.value.href)} onClick={onClick}>
    <img src={src} alt={alt} className="logo" title={title} />
  </Link>
);
 
const LanguageMenu = ({ lang, languages, regionIcon }) => {
  if(lang.toLowerCase() !== 'en' && lang.toLowerCase() !== 'en-ae'){
    languages = languages.filter(v=>  v.fields.code.value.toLowerCase()!=='en')
  }
  if(lang.toLowerCase() == 'en' || lang.toLowerCase() == 'en-ae'){
    languages = languages.filter(v=>  v.fields.code.value.toLowerCase()=='en')
  }

  let countryCode = '';
  return (
    <div className="languages">
      {regionIcon && regionIcon.value && regionIcon.value.alt && <Icon icon={{ ...regionIcon.value }} />}
      {languages?.map(language => {
        return (
          <div className={classNames("language")} key={language.fields.code.value}>
            { language.fields.targetName.value}
          </div>
        );
      })}
    </div>
  );
};
const HeaderProgressBar = ({ steps, checkoutProgressIndex }) => {
  const history = useHistory();
  const query = useQuery();
  const onProgressClick = (evt, step) => {
    if (!step.disabled) {
      const link = appendQuery(step.route, query);
      redirect(history, link, false);
    }
  };
  return (
    <ul className="header-progress-bar">
      {steps?.length > 0 &&
        steps?.map((step, i) => (
          <li key={step?.label} onClick={evt => onProgressClick(evt, step)}>
            <a className="linkWrap">
              <p
                className={classNames("step", {
                  active: i === Number(checkoutProgressIndex) - 1,
                  disabled: step.disabled
                })}
              >
                {i + 1}
              </p>
            </a>
          </li>
        ))}
    </ul>
  );
};

const mapStateToProps = state => {
  return {
    user: selectUserState(state),
    headerHeight: selectHeaderHeight(state),
    progressBarIndex: selectShowCheckoutProgressBar(state),
    progressBarData: selectProgressBarData(state)
  };
};

const mapDispatchToProps = dispatch => ({
  setHeaderHeight: val => dispatch(setHeaderHeight(val)),
  toggleMenu: () => dispatch(toggleMenu()),
  dispatch
});
export default connect(mapStateToProps, mapDispatchToProps)(HeaderBar);
